export const profileLinks = [
  {
    label: "Connect On LinkedIn",
    href: "https://www.linkedin.com/in/richardtmiles/",
    className: "linkedin",
  },
  {
    label: "Check Out My Resume",
    href: "https://github.com/RichardTMiles/Resume/blob/main/RichardTylerMiles.pdf",
    className: "resume",
  },
  {
    label: "My Projects on GitHub",
    href: "https://github.com/RichardTMiles/",
    className: "github",
  },
] as const;

export const portfolioItems = [
  {
    label: "Miles Systems",
    href: "https://miles.systems/",
    image: "/milessystems/view/img/work/milesSystemsLLC.png",
  },
  {
    label: "Assessorly",
    href: "https://www.assessorly.com/",
    image: "/milessystems/view/img/work/assessorly.png",
  },
  {
    label: "Chess.com",
    href: "https://www.chess.com/",
    image: "/milessystems/view/img/work/chess.png",
  },
  {
    label: "Drop-in Gaming",
    href: "https://www.linkedin.com/company/drop-in-gaming/",
    image: "/milessystems/view/img/work/dropingaming.jpeg",
  },
  {
    label: "McKesson",
    href: "https://www.linkedin.com/company/mckesson/",
    image: "/milessystems/view/img/work/mckesson.jpeg",
  },
  {
    label: "Praesidium, Inc.",
    href: "https://www.linkedin.com/company/praesidium-inc-/",
    image: "/milessystems/view/img/work/praesidium.jpeg",
  },
  {
    label: "Southern Methodist University",
    href: "https://www.smu.edu/",
    image: "/milessystems/view/img/work/SMU.png",
  },
  {
    label: "University of North Texas",
    href: "https://www.unt.edu/",
    image: "/milessystems/view/img/work/northtexas.png",
  },
] as const;
